import { render, staticRenderFns } from "./ProjectAttachmentsNew.vue?vue&type=template&id=5e33f0dc&scoped=true"
import script from "./ProjectAttachmentsNew.vue?vue&type=script&lang=ts"
export * from "./ProjectAttachmentsNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectAttachmentsNew.vue?vue&type=style&index=0&id=5e33f0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33f0dc",
  null
  
)

export default component.exports